var _defs, _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 46.83 48.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #c5dbfd;\n      }\n\n      .cls-3 {\n        fill: #f2f7fe;\n      }\n\n      .cls-4 {\n        fill: #2578f6;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.72,
    y: 11.85,
    width: 21.4,
    height: 24.52
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 23.42,
    cy: 24.11,
    r: 22.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.42,1.61C11.01,1.61.92,11.7.92,24.11s10.09,22.5,22.5,22.5,22.5-10.09,22.5-22.5S35.82,1.61,23.42,1.61ZM23.42,45.11c-11.58,0-21-9.42-21-21S11.84,3.11,23.42,3.11s21,9.42,21,21-9.42,21-21,21Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    className: "cls-4",
    d: "M23.41,11.85c-3.43,0-6.22,2.78-6.22,6.21,0,3.43,2.78,6.22,6.21,6.22,3.43,0,6.22-2.78,6.22-6.21h0c0-3.44-2.78-6.21-6.21-6.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    className: "cls-4",
    d: "M34.12,34.26v-1.6c0-3.87-3.13-7-6.99-7.01,0,0,0,0,0,0h-7.4c-3.87,0-7,3.13-7,7v1.6c0,1.16.94,2.1,2.1,2.1h17.2c1.16,0,2.1-.93,2.1-2.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.f56243e1bd1ffdf4d0a48cbe4c8da49e.svg";
export { ForwardRef as ReactComponent };